export default __webpack_public_path__ + "static/media/scott baugh.b290a463.jpg";